import { render } from "./ChildPage.vue?vue&type=template&id=db1b7c3e"
import script from "./ChildPage.vue?vue&type=script&lang=js"
export * from "./ChildPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__